import { MobileMenu } from './MobileMenu';

let wwzrdsMobileMenu;

document.addEventListener('DOMContentLoaded', () => {
	const mobileMenuElement = document.querySelector('.catalog-menu-mobile');
	if (mobileMenuElement) {
		wwzrdsMobileMenu = new MobileMenu(mobileMenuElement);
	}
});

export { wwzrdsMobileMenu };


